import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#DE0009" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink href="https://www.facebook.com/sanshosushi/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Victoria Sushi Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/victoriasushi_langford/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Victoria Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#DE0009" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink href="https://www.facebook.com/sanshosushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Victoria Sushi Facebook"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/victoriasushi_langford/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Victoria Sushi Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
